import utils from '@eitje/utils'
import {Organisation, Invoice} from '@eitje/api'

export const useOrganisationFilter = ({fixedFilter}) => {
	let items = Organisation.useAll({joins: ['environments']})
	const invoices = Invoice.useWhereNot({status: ['paid', 'disregard']})

	if (fixedFilter === 'withCoordinates') {
		items = items.filter(({environments}) => environments?.some(({lat, lng}) => lat && lng))
	}

	if (fixedFilter === 'withUnpaidInvoices') {
		items = items.filter(({id}) => invoices.some(({organisation_id}) => organisation_id === id))
	}

	const filterFn = (item, filterValues) => {
		const {id, organisation_id, organisation_ids} = item
		const ids = utils.alwaysArray(organisation_id || organisation_ids || id)

		return ids.some(id => filterValues.includes(id))
	}

	return {
		items,
		filterFn,
		labelField: 'name',
	}
}
